var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMaterialPredominante = function SvgMaterialPredominante(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 3C3.333 3.018 4 3.684 4 5V6C4 7.333 3.333 8 2 8V3ZM2 10H6.143C7.38 10 8 10.667 8 12V13C8 14.333 7.381 15 6.143 15H2V10ZM7.875 3H11.125C12.375 3 13 3.667 13 5V6C13 7.333 12.375 8 11.125 8H7.875C6.625 8 6 7.333 6 6V5C6 3.667 6.625 3 7.875 3ZM11.875 10H15.125C16.375 10 17 10.667 17 12V13C17 14.333 16.375 15 15.125 15H11.875C10.625 15 10 14.333 10 13V12C10 10.667 10.625 10 11.875 10ZM7.875 17H11.125C12.375 17 13 17.667 13 19V20C13 21.333 12.375 22 11.125 22H7.875C6.625 22 6 21.333 6 20V19C6 17.667 6.625 17 7.875 17ZM16.875 17H20.125C21.375 17 22 17.667 22 19V20C22 21.333 21.375 22 20.125 22H16.875C15.625 22 15 21.333 15 20V19C15 17.667 15.625 17 16.875 17ZM2 17C3.333 17.018 4 17.684 4 19V20C4 21.333 3.333 22 2 22V17Z",
    fill: "#3A3A47"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMaterialPredominante, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/material-predominante.b9431c17.svg";
export { ForwardRef as ReactComponent };